export const getOrdersByElderByDate = /* GraphQL */ `
  query GetOrdersByElderByDate(
    $elderId: ID
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getOrdersByElderByDate(
      elderId: $elderId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        individualId
        restaurantId
        elderId
        date
        mealSlot
        deliveryBy
        status
        county
        countyOpenStatus
        isTemporarilyLocked
        category
        transactionId
        deliveryGroupId
        deliveryGroupSortOrder
        source
        groupPurchaseStatus
        orderQuoteId
        isAudited
        nextStatusCheckAt
        issuePriority
        issueSummary
        deliveryStaffId
        deliveryStaffOrderId
        deliveryStaffFee
        deliveryStaffFeeCalculationMethod
        tier
        tierExpiredAt
        noteForDelivery
        noteForMeal
        note
        groupPurchaseDietaryNote
        mealItems {
          name
          quantity
          price
          cost
          note
          surcharges {
            name
            price
          }
        }
        totalCost
        total
        quantity
        subtotal
        discount
        discountCode
        discountDetails
        extraFee
        platformFee
        paymentMethod
        direction {
          startAddress
          startLocation {
            lat
            lng
          }
          endAddress
          endLocation {
            lat
            lng
          }
          distance
          duration
          distanceInMeters
          durationInSeconds
          overviewPolyline
          bounds {
            northeast {
              lat
              lng
            }
            southwest {
              lat
              lng
            }
          }
        }
        createdAt
        createdBy
        updatedAt
        updatedBy
        orderGroupId
        referenceId
        linkGroupElderIds
        cancellationReason
        cancellationNote
        directionServiceProvider
        restaurant {
          name
        }
      }
      nextToken
    }
  }
`;
